module.exports = __webpack_public_path__ + "static/media/cellfinate_social_5.fb361d46.jpg";